<template>
  <div>
    <v-snackbar v-model="$api.maintenance" :timeout="-1" top data-cy="maintenance-toast">
      {{ $t('maintenance-mode') }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" :loading="true"></v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: 'AppApiNotifications',
}
</script>

<i18n>
{
	"en": {
		"maintenance-mode": "Maintenance mode: the platform is being updated. Thank you for your patience."
	},
	"es": {
		"maintenance-mode": "Modo de mantenimiento: la plataforma se actualiza. Gracias por su paciencia."
	},
	"fr": {
		"maintenance-mode": "Mode maintenance : la plateforme est en cours de mise à jour. Merci de patienter quelques instants."
	},
	"it": {
		"maintenance-mode": "Modalità manutenzione: la piattaforma è in fase di aggiornamento. Grazie per la pazienza."
	},
	"pt": {
		"maintenance-mode": "Modo de manutenção: a plataforma está a ser atualizada. Obrigado pela sua paciência."
	},
	"pl": {
		"maintenance-mode": "Tryb konserwacji: platforma jest aktualizowana. Dziękujemy za cierpliwość."
	}
}
</i18n>